import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=95487e6a&scoped=true"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"
import style0 from "./broadcast.vue?vue&type=style&index=0&id=95487e6a&prod&lang=scss"
import style1 from "./broadcast.vue?vue&type=style&index=1&id=95487e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95487e6a",
  null
  
)

export default component.exports